import { create } from 'zustand'

import { connectStoreToRedux } from '@/utils'
import { ComponentType } from '@/utils/api'

export type SupportedDuplicateTypes = 'Solution' | 'EG' | ComponentType
type DuplicateComponent = {
  type: SupportedDuplicateTypes | undefined
  id: string | undefined
  setConfig(param: { type: SupportedDuplicateTypes; id: string }): void
  removeConfig: VoidFunction
  getConfig: () => {
    type: SupportedDuplicateTypes | undefined
    id: string | undefined
  }
}
const duplicateComponentStore = create<DuplicateComponent>((set, get) => ({
  getConfig: () => ({ id: get().id, type: get().type }),
  id: undefined,
  removeConfig: () => set({ id: undefined, type: undefined }),
  setConfig: ({ type, id }) => set({ id, type }),
  type: undefined,
}))

export const useResetConfig = () =>
  duplicateComponentStore((state) => state.removeConfig)
export const useSetConfig = () =>
  duplicateComponentStore((state) => state.setConfig)

export const useDuplicateComponentData = () =>
  duplicateComponentStore((state) => ({
    id: state.id,
    type: state.type,
  }))

connectStoreToRedux('appsyncRefetch', duplicateComponentStore)
